import { ContractState } from '../../states/ContractState';
import { Action } from 'redux';
import * as CommonFunctions from '../Common/Functions';
import ContractIAImportReducer from './Contract.IAImport.Reducer';
import ContractAddendumsReducer from './Contract.Addendums.Reducer';
import ContractAccessReducer from './Contract.Access.Reducer';
import ContractBaseReducer from './Contract.Base.Reducer';
import ContractStagesByContractReducer from './Contract.StagesByContract.Reducer';
import ContractStagesByAddendumReducer from './Contract.StagesByAddendum.Reducer';
import ContractConceptsReducer from './Contract.Concepts.Reducer';
import ContractBranchesReducer from './Contract.Branches.Reducer';
import ContractNegotiationsReducer from './Contract.Negotiations.Reducer';
import ContractNegotiationConceptsReducer from './Contract.Negotiations.Concepts.Reducer';
import ContractNegotiationVersionsReducer from './Contract.Negotiations.Versions.Reducer';
import ContractNegotiationVersionConceptsReducer from './Contract.Negotiations.VersionConcepts.Reducer';
import ContractStageCyclesReducer from './Contract.StageCycles.Reducer';
import ContractAssociationsReducer from './Contract.Associations.Reducer';
import ContractCommissionConceptsReducer from './Contract.CommissionConcepts.Reducer';
import ContractCommissionAgentsReducer from './Contract.CommissionAgents.Reducer';
import ContractConceptPaymentScheduleReducer from './Contract.ConceptPaymentSchedule.Reducer';
import ContractConceptConceptsReducer from './Contract.ConceptConcepts.Reducer';
import ContractConceptSponsorsReducer from './Contract.ConceptSponsors.Reducer';
import ContractStageLinkVisitReducer from './Contract.StageLinkVisit.Reducer';
import ContractStageItemsReducer from './Contract.StageItems.Reducer';

export const CombinedContractReducer = CommonFunctions.reduceReducers<ContractState>(
  ContractBaseReducer,
  ContractIAImportReducer,
  ContractAddendumsReducer,
  ContractAccessReducer,
  ContractStagesByContractReducer,
  ContractStagesByAddendumReducer,
  ContractConceptsReducer,
  ContractBranchesReducer,
  ContractNegotiationsReducer,
  ContractNegotiationConceptsReducer,
  ContractNegotiationVersionsReducer,
  ContractNegotiationVersionConceptsReducer,
  ContractStageCyclesReducer,
  ContractStageItemsReducer,
  ContractAssociationsReducer,
  ContractCommissionConceptsReducer,
  ContractCommissionAgentsReducer,
  ContractConceptPaymentScheduleReducer,
  ContractConceptConceptsReducer,
  ContractConceptSponsorsReducer,
  ContractStageLinkVisitReducer
);
